const Component = () => import('./DietaryPreferences');

export { Component };
